import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ThirdPartyCostPayment\GetThirdPartyCostListController::__invoke
* @see app/Http/Controllers/ThirdPartyCostPayment/GetThirdPartyCostListController.php
* @route '/api/third_party_cost'
*/
const GetThirdPartyCostListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetThirdPartyCostListController.url(options),
    method: 'get',
})

GetThirdPartyCostListController.definition = {
    methods: ["get","head"],
    url: '/api/third_party_cost',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ThirdPartyCostPayment\GetThirdPartyCostListController::__invoke
* @see app/Http/Controllers/ThirdPartyCostPayment/GetThirdPartyCostListController.php
* @route '/api/third_party_cost'
*/
GetThirdPartyCostListController.url = (options?: RouteQueryOptions) => {
    return GetThirdPartyCostListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ThirdPartyCostPayment\GetThirdPartyCostListController::__invoke
* @see app/Http/Controllers/ThirdPartyCostPayment/GetThirdPartyCostListController.php
* @route '/api/third_party_cost'
*/
GetThirdPartyCostListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetThirdPartyCostListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ThirdPartyCostPayment\GetThirdPartyCostListController::__invoke
* @see app/Http/Controllers/ThirdPartyCostPayment/GetThirdPartyCostListController.php
* @route '/api/third_party_cost'
*/
GetThirdPartyCostListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetThirdPartyCostListController.url(options),
    method: 'head',
})

export default GetThirdPartyCostListController